import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components';

import { scrollToTopButtonStyle } from './ScrollToTopButton.css';

// Resize matters too: the threshold is viewport-relative, so it moves when the window does.
const subscribeToScrollPosition = (onChange: () => void) => {
  window.addEventListener('scroll', onChange, { passive: true });
  window.addEventListener('resize', onChange, { passive: true });

  return () => {
    window.removeEventListener('scroll', onChange);
    window.removeEventListener('resize', onChange);
  };
};

const isScrolledPastFirstViewport = () => window.scrollY > window.innerHeight;

export const ScrollToTopButton = () => {
  const { t } = useTranslation(['common']);

  const isScrolledDown = useSyncExternalStore(subscribeToScrollPosition, isScrolledPastFirstViewport);

  if (!isScrolledDown) return null;

  return (
    <Button
      aria-label={t('common:infiniteScroll.scrollToTop')}
      className={scrollToTopButtonStyle}
      emphasis="secondary"
      icon="ArrowUp"
      onClick={() => window.scrollTo({ behavior: 'smooth', top: 0 })}
    />
  );
};
